import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { selectSingleBatchData, selectBatchList } from '@reducers/batch';
import { usePanelViewMode } from '@v2/pages/machines/hooks/usePanelViewMode';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import type { Machine } from '@interfaces/machines';
import type { RunningBatchProps } from '@v2/pages/machines/common/components/RunningBatch/RunningBatch';

export interface UseManageRunningBatchParams extends Pick<RunningBatchProps, 'currentBatchId'> {}

export const useManageRunningBatch = (params: UseManageRunningBatchParams) => {
  const { currentBatchId } = params;

  const selectedItem = useSelector(selectSelectedItem) as Machine;
  const batch = useSelector(selectSingleBatchData);
  const batchList = useSelector(selectBatchList);

  const { panelViewMode } = usePanelViewMode();
  const { detailsWidth } = useDeviceSize();

  const isCachedBatchIsCurrentBatch = batch?.data && currentBatchId != null && batch?.data?.productionBatchId === Number(currentBatchId);
  const currentBatchInBatchList = currentBatchId != null && batchList.find((b) => b.productionBatchId === Number(currentBatchId));

  const batchForRender = isCachedBatchIsCurrentBatch ? batch?.data : currentBatchInBatchList ? currentBatchInBatchList : null;

  return {
    selectedItem,
    batch,
    panelViewMode,
    detailsWidth,
    batchForRender,
  };
};
